export function cls(conditionalClasses) {
  return Object.entries(conditionalClasses)
    .filter(([, condition]) => condition)
    .map(([className]) => className)
    .join(' ')
}
